import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux-store";
import { loadDrivers } from "./index";
import * as selectors from "./selectors";

export const useDrivers = () => {
  const dispatch = useAppDispatch();
  const status = useSelector(selectors.selectStatus);
  const drivers = useSelector(selectors.selectDrivers);
  const driversFilteredByTeams = useSelector(
    selectors.selectDriversFilteredByTeams
  );
  useEffect(() => {
    dispatch(loadDrivers());
  }, [dispatch]);
  return {
    status,
    drivers,
    driversFilteredByTeams,
  };
};
